// js/sections/geo-location-popup.js
import { Drawer as Drawer3 } from "//unamari.com/cdn/shop/t/54/assets/theme.js?v=115076385660785418411764578285";

class GeoLocationPopup extends Drawer3 {
  constructor() {
    super();
    this.state = {
      currentView: 'initial',
      isOnlyOnce: this.hasAttribute('only-once')
    };

    // Cache DOM elements
    this.initialView = this.querySelector('[data-initial-view]');
    this.changeView = this.querySelector('[data-change-view]');
    this.nextStepButton = this.querySelector('[data-next-step-button]');
    this.changeLink = this.querySelector('[data-change-link]');
    this.cancelButton = this.querySelector('[data-cancel-button]');
    this.form = this.querySelector('#GeoLocationForm');
    this.countrySelect = this.querySelector('[data-country-selector]');
    this.languageSelect = this.querySelector('[data-language-selector]');

    this.setupEventListeners();
  }

  connectedCallback() {
    super.connectedCallback();
    this.setupEventListeners();

    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }

  get initialFocus() {
    return false;
  }

  get shouldAppendToBody() {
    return false;
  }

  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }

  get shouldAppearAutomatically() {
    const storageState = this.checkStorage();
    return !(
      storageState.filled ||
      (this.state.isOnlyOnce && storageState.appeared)
    );
  }

  setupEventListeners() {
    // Initial view - continue button
    this.nextStepButton?.addEventListener('click', () => {
      this.saveToStorage();
      this.close();
    });

    // Change country/language link
    this.changeLink?.addEventListener('click', () => {
      this.showChangeView();
    });

    // Cancel button in form view
    this.cancelButton?.addEventListener('click', () => {
      this.showInitialView();
    });

    // Close button and overlay click
    this.querySelector('[data-close-button]')?.addEventListener('click', () => {
      this.saveToStorage();
      this.close();
    });

    // Click outside to close
    this.addEventListener('click', (event) => {
      if (event.target === this) {
        this.saveToStorage();
        this.close();
      }
    });

    // Form submission
    if (this.form) {
      this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
    }
  }

  // Helper method to save to appropriate storage
  saveToStorage() {
    const storage = this.state.isOnlyOnce ? localStorage : sessionStorage;
    storage.setItem('theme:geo-location-filled', 'true');
    storage.setItem('theme:geo-location-appeared', 'true');
  }

  // Helper method to check storage
  checkStorage() {
    const storage = this.state.isOnlyOnce ? localStorage : sessionStorage;
    return {
      filled: storage.getItem('theme:geo-location-filled') === 'true',
      appeared: storage.getItem('theme:geo-location-appeared') === 'true'
    };
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const submitButton = this.form.querySelector('[data-submit-button]');
    if (submitButton) {
      submitButton.disabled = true;
    }

    try {
      // Save to appropriate storage before submitting
      this.saveToStorage();

      // Use native form submission
      this.form.submit();
    } catch (error) {
      console.error('Form submission error:', error);
      if (submitButton) {
        submitButton.disabled = false;
      }
    }
  }

  close() {
    this.setAttribute('hidden', '');
    document.documentElement.classList.remove('lock-scroll');
    this.saveToStorage();
  }

  showInitialView() {
    this.state.currentView = 'initial';
    this.initialView.hidden = false;
    this.changeView.hidden = true;
  }

  showChangeView() {
    this.state.currentView = 'change';
    this.initialView.hidden = true;
    this.changeView.hidden = false;
  }

  _setInitialPosition() {
    this.style.top = null;
    this.style.bottom = "0px";
    this.style.left = document.dir === "ltr" ? null : "0px";
    this.style.right = document.dir === "rtl" ? "auto" : "0px";
  }
}

if (!window.customElements.get('geo-location-popup')) {
  window.customElements.define('geo-location-popup', GeoLocationPopup);
}
